import {post} from "@/net/http";

// 首页数据
export const getReportInfoLoop = (params) => post('/api/getReportInfoLoop', params);
// 检测16项详情
export const getReportLoopItem = (params) => post('/api/getReportLoopItem', params);
// 全部数据概览
export const getReportLoopItemAll = (params) => post('/api/getReportLoopItemAll', params);
// 营养素综合详情
export const getReportLoopItemNutritionAll = (params) => post('/api/getReportLoopItemNutritionAll', params);
// 营养素单项详情
export const getReportLoopItemNutrition = (params) => post('/api/getReportLoopItemNutrition', params);
// 调理状态评估
export const getReportInfoCompare = (params) => post('/api/getReportInfoCompare', params);
// 身体内脏单项详情
export const getReportLoopItemOrgans = (params) => post('/api/getReportLoopItemOrgans', params);

// 全部数据概览 v2 版本
export const getReportComprehensiveAll = (params) => post('/api/getReportComprehensiveAll', params);

// 全部调理方案列表
export const getReportConditioningList = (params) => post('/api/getReportConditioningList', params);
// 调理方案详情
export const getReportConditioningInfo = (params) => post('/api/getReportConditioningInfo', params);
// 对比报告详情
export const reportCompareInfoH5 = (params) => post('/api/reportCompareInfoH5', params);
// 新版调理方案详情
export const getReportConditioningInfoH5 = (params) => post('/api/getReportConditioningInfoH5', params);

